export default {
  namespace: 'agents',

  // Sorting options
  sorting: {},

  // Filter options
  filters: {
    search: {
      label: 'Search'
    }
  }
};
